import MyHeader from '../../Home/MyHeader';
import {ConfigProvider} from 'antd';
import MyFooter from '../../Home/MyFooter';
import img1 from '../../resource/news_4_img_1.png';
import '../NewsStyles.css';

export default function Index() {
  return (
    <ConfigProvider
      theme={{
        components: {
          Menu: {
            horizontalItemSelectedBg: '#ffffff',
            horizontalItemSelectedColor: '#203864',
            itemColor: '#203864',
            itemPaddingInline: 24,
            activeBarHeight: 0,
          },
          Collapse: {
            contentPadding: 0
          }
        },
      }}
    >
      <MyHeader/>
      <main className="news-room-body">
        <div className="new-room-content">
          <h1>异格技术自研高端FPGA芯片P2成功点亮！</h1>
          <p className="news-room-date">2026年4月9日</p>
          <img src={img1} alt="Eagle Chip"/>
          <br/>
          <p>
            2026年4月9日，苏州异格技术迎来又一历史性时刻——自主研发的高性能FPGA芯片P2，顺利实现一次性点亮。这不仅是一次技术验证的成功，更是公司向高端FPGA市场发起总攻的里程碑。
          </p>
          <p>
            从2022年创立以来，异格技术一直致力于“填补国产高端FPGA的空白”。
          </p>
          <p>
            TC1，是从零出发，验证了核心架构与自主EDA工具的可行性。
          </p>
          <p>
            TC2、TC3，是ECH与ECM两个系列同步点亮的双重惊喜，两小时内快速点亮，创造了先进工艺国内FPGA芯片最快点亮记录。
          </p>
          <p>
            P1，是异格首款量产FPGA芯片的破晓，标志着公司跨越从设计到量产的关键门槛，产品开始进入市场试点。
          </p>
          <p>
            而今，P2在大规模逻辑阵列、高带宽系统互连领域全面跃升，是公司迄今规模最大、集成度最高的FPGA芯片。它延续“高性能、低功耗、差异化”的产品理念，在工艺制程、功能特性与接口性能等核心维度上持续领跑同等容量产品。P2的顺利攻坚，标志着异格技术在高端可编程逻辑器件的设计范式与工程底蕴上，已建立起更为稳固的核心能力。
          </p>
          <p>
            接下来，异格技术将全速推进新一代FPGA芯片的研发，以传统FPGA市场为基石，AI推理等新兴市场为抓手，开启AI智能时代的新篇章。
          </p>
        </div>
      </main>
      <MyFooter/>
    </ConfigProvider>
  );
}